import { render, staticRenderFns } from "./ProductDialog.vue?vue&type=template&id=75167262&scoped=true&"
import script from "./ProductDialog.vue?vue&type=script&lang=ts&"
export * from "./ProductDialog.vue?vue&type=script&lang=ts&"
import style0 from "./ProductDialog.vue?vue&type=style&index=0&id=75167262&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75167262",
  null
  
)

export default component.exports